
import CommonUtils from "@/common-utils";
import Constants from "@/constants";
import Template1 from "@/views/templates/template1.vue";
import axios from "axios";
import _, { toNumber } from "lodash-es";
import throttle from "lodash-es/throttle";
import debounce from "lodash-es/debounce";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import Teleport from "vue2-teleport";
import { ProductVO } from "../product/vo/product.vo";
import MainImgViewerPop from "./MainImgViewerPop.vue";
import VirtualCategory from "./VirtualCategory.vue";
import { DisplayOVO, LayoutDisplayItemOVO, LayoutOVO, MstLayoutVO } from "./vo/main.vo";
import TimeSale from "./TimeSale.vue";

@Component({ components: { VirtualCategory, MainImgViewerPop, Teleport, Template1, TimeSale } })
export default class Layout extends Vue {
  static readonly DISPLAY_CD_TIME_SALE = 16;

  @Prop({ default: "" })
  layoutCd;
  @Prop()
  layoutVo!: LayoutOVO;
  @Prop({ default: false })
  active!: boolean;
  @PropSync("currentSubMenuIdx", { default: 0 })
  selectedVirtualCategoryIndex!: number;

  mainImagePopOpened = false;
  currentMainImageDisplay = {} as DisplayOVO;
  layout = {} as MstLayoutVO;
  aiRecommendedProducts = [] as Array<ProductVO>; // 추천상품(내가본상품)
  timeSales = [] as Array<LayoutDisplayItemOVO>;

  // 메인이미지
  swiperMain = {
    slidesPerView: this.$isMobile ? 1 : 3,
    centeredSlides: this.$isMobile ? false : true,
    loop: true,
    pagination: { el: ".swiper-pagination", type: "fraction" },
    autoplay: { delay: 3000, pauseOnMouseEnter: true },
    nested: this.nested,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  // 상품 횡스크롤 숫자 다를시 저장 var
  notDefaultSlidesPerView = 0;

  // 상품 횡스크롤 공통 옵션
  swiperOptionProducts = {
    slidesPerView: this.$isMobile ? 2.8 : 4,
    spaceBetween: this.$isMobile ? 10 : 20,
    nested: this.nested,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  // TODO 융통성있게 변경
  get nested(): boolean {
    return true;
  }

  // 전체 쿠폰 다운로드 가능?
  get isAllCouponsDownloadable(): boolean {
    let result = false;
    this.layout.displays.forEach((display) => {
      display.couponDisplayItems.forEach((couponDisplayItem) => {
        if (couponDisplayItem.maxDownloadableCouponCount > 0) {
          result = true;
          return;
        }
      });
    });
    return result;
  }
  // 성별 string
  get genderStr() {
    return this.layoutVo.gender == "01" ? this.$t("t0727") : this.$t("t0728");
  }

  // 연령 그룹 추천 상품 헤더
  get ageGroupAiProductsHeader() {
    if (!this.layoutVo.memCd || !this.layoutVo.gender || !this.layoutVo.ageGroupStr) {
      // 지금 가장 핫한 상품
      return this.$t("promotion.t0001");
    }

    const genderStr = this.layoutVo.gender == "01" ? this.$t("t0727") : this.$t("t0728");

    if (toNumber(this.layoutVo.ageGroupStr) < 50) {
      // 지금 {0}대 {1}에게 가장 핫한 상품
      return this.$t("promotion.t0002", [this.layoutVo.ageGroupStr, genderStr]);
    } else {
      // 지금 {0}대 이상 {1}에게 가장 핫한 상품
      return this.$t("promotion.t0003", [this.layoutVo.ageGroupStr, genderStr]);
    }
  }

  // 추천 상품 헤더
  get recommendedAiProductsHeader() {
    if (this.layoutVo.memNm) {
      // {거시기}님, 이런 상품 어때요?
      return this.$t("promotion.t0004", [this.layoutVo.memNm]);
    }
    // 고객님, 이런 상품 어때요?
    return this.$t("promotion.t0005");
  }

  // 레이아웃 구조 생성
  createLayoutStructure(layoutOVO: LayoutOVO): MstLayoutVO {
    const layout = layoutOVO.layout;
    layout.displays = layoutOVO.displays;
    layout.displays &&
      layout.displays.forEach((display) => {
        display.displayItems = [];
        display.couponDisplayItems = [];
        if(layoutOVO.displayItems.length >1){
        display.swiperOption = this.getSwiperOptionForSlidesPerView(display);
        }
      


        layoutOVO.displayItems &&
          layoutOVO.displayItems.forEach((displayItem) => {
            displayItem.products = [];
            // 진열 아이템
            if (displayItem.displaySeq == display.seq) {
              display.displayItems.push(displayItem);
            }
            layoutOVO.virtualProducts &&
              layoutOVO.virtualProducts.forEach((product) => {
                // 가상카테고리 상품
                if (product.virtualCategoryCd == displayItem.virtualCategoryCd) {
                  displayItem.products.push(product);
                }
              });
          });
        // 쿠폰
        layoutOVO.couponDisplayItems &&
          layoutOVO.couponDisplayItems.forEach((couponDisplayItem) => {
            if (couponDisplayItem.displaySeq == display.seq) {
              display.couponDisplayItems.push(couponDisplayItem);
            }
          });
      });

      // displayCd 19 / 20 여기서 스와이퍼 레이아웃 세팅 다시 해줌 (모바일일때)
      if (this.$isMobile) {
        layout.displays.forEach((display)=>{
          if(display.displayCd == 19 || display.displayCd == 20){
            display.swiperOption = {...display.swiperOption, slidesPerView: this.notDefaultSlidesPerView};
          }
        })
      }

    return _.cloneDeep(layout);
  }

  @Watch("active")
  onLayoutActivated() {
    if (this.active) {
      window.addEventListener("scroll", this.handleScroll);
    } else {
      window.removeEventListener("scroll", this.handleScroll);
    }
    // 2depth 플로팅 메뉴 없애줌
    this.$refs.tabMenu &&
      (this.$refs.tabMenu as Array<HTMLDivElement>).forEach((tabMenu) => {
        tabMenu.classList.remove("fix");
      });
    this.$emit("update:subMenuItems", []);
  }

  // 스크롤 따라서 상단 navigation 제어
  handleScroll = throttle(this.handleTopNavigation, 100);
  handleTopNavigation(): void {
    try {
      if (!this.active) {
        return;
      }
      let isFixed = false; // 서브 메뉴가 고정됨?
      const virtualCategories = this.$refs.virtualCategory as Array<Vue>;
      // 2depth 메뉴 고정
      virtualCategories.forEach((virtualCategory) => {
        /////////////////////////
        ///// 2depth 메뉴바
        /////////////////////////
        const tabMenu = virtualCategory.$refs.tabMenu as HTMLDivElement; // 이거 왜 배열로 반환을 안하지??
        const offsetTop = window.pageYOffset + tabMenu.getBoundingClientRect().top;
        if (offsetTop < window.scrollY && offsetTop + tabMenu.offsetHeight >= window.scrollY) {
          const seq = Number(tabMenu.getAttribute("data-seq"));
          this.$emit("update:subMenuItems", this.layout.displays.filter((display) => display.seq == seq)[0].displayItems); // 스크롤이 tabMenu 아래로 내려가면 navigation 고정
          tabMenu.classList.add("fix");
          isFixed = true;
        } else {
          tabMenu.classList.remove("fix");
        }

        /////////////////////////
        ///// 프로모션 스크롤내0야ㅗㄹ0ㅔㄴㅇ레
        /////////////////////////
        const container = virtualCategory.$refs.virtualCategoryWrap as Array<HTMLDivElement>;
        for (let i = 0; i < container.length; i++) {
          const offsetTop = window.pageYOffset + container[i].getBoundingClientRect().top;
          if (offsetTop <= window.window.scrollY + 120) {
            this.selectedVirtualCategoryIndex = i;
          }
        }
      });
      if (!isFixed) {
        this.$emit("update:subMenuItems", []);
      }
    } catch (e) {
      // ignore
      return;
    }
  }

  // 이미지 로드되면 layout 영역 height가 바뀜. 부모쪽 스와이퍼 update autoheight 발생 시켜야함
  onImageLoaded = debounce(this.onLayoutUpdated, 200);
  onLayoutUpdated() {
    this.$nextTick(() => {
      this.$emit("layout-update");
    });
  }

  // 활성 탭 변경
  onTabIndexChanged(display: DisplayOVO, index: number) {
    display.selectedIndex = index;
    this.layout = Object.assign({}, this.layout);
    this.onLayoutUpdated();
  }

  // 유튜브 링크
  getEmbededYoutubeLink(link: string) {
    link = link.replace(/watch\?v=/, "embed/");
    if (link.includes("?") == false) {
      link = link.replace(/&/, "?");
    }
    return link;
  }

  // 쿠폰 다운로드
  downloadCoupon(coupon: LayoutDisplayItemOVO) {
    // 일단 로그인 체크하고
    axios.get("/login/ping").then((r) => {
      if (r.data != "pong") {
        if (this.$route.name == "Main") {
          this.$router.push({ name: "Login", params: { toName: "Main" } });
        } else {
          this.$router.push({ name: "Login", params: { toName: "Promotion", layoutCd: this.layoutCd } });
        }
        return;
      }

      axios
        .post("/coupon", coupon)
        .then(() => {
          this.$toast(this.$t("coupon.a0009"));
          --coupon.maxDownloadableCouponCount;
        })
        .catch(() => {
          //TODO 실패 사유
        });
    });
  }

  // 쿠폰 전체 다운로드
  downloadAllCoupon() {
    const layoutCd = this.layout.layoutCd.toString();

    // 일단 로그인 체크하고
    axios.get("/login/ping").then((r) => {
      if (r.data != "pong") {
        if (this.$route.name == "Main") {
          this.$router.push({ name: "Login", params: { toName: "Main" } });
        } else {
          this.$router.push({ name: "Login", params: { toName: "Promotion", layoutCd: layoutCd } });
        }
        return;
      }

      axios
        .get(`/coupon/promotion/${layoutCd}`)
        .then(() => {
          this.$toast(this.$t("coupon.a0009"));
          // 모든 쿠폰 수량 -1
          this.layout.displays.forEach((display) => {
            display.couponDisplayItems.forEach((couponDisplayItem) => {
              --couponDisplayItem.maxDownloadableCouponCount;
            });
          });
        })
        .catch(() => {
          //TODO 실패 사유
        });
    });
  }
  isSingleSwiper(item: DisplayOVO){
    return item.displayItems.flatMap(val=> val.products).length > 1 ;
  }

  // 디스플레이별 옵션변경은 여기서 처리
  getSwiperOptionForSlidesPerView(item: DisplayOVO) {
    // 22 displayCd 삭제되서 주석
    //const defaultOption = [1, 22, 26, 27].includes(item.displayCd) ? this.swiperMain : this.swiperOptionProducts;
    const defaultOption = [1, 26, 27].includes(item.displayCd) ? this.swiperMain : this.swiperOptionProducts;
    const option = Object.assign({}, defaultOption as any);

    if (this.$isMobile) {
      //ai쪽도 페이지 뷰 동일하게 맞춰주기위해 이런코드 들어감...
      if(item.displayCd == 5 && option.slidesPerView != item.slidesPerViewMobile){
        this.notDefaultSlidesPerView = item.slidesPerViewMobile;
       }
       item.slidesPerViewMobile && (option.slidesPerView = item.slidesPerViewMobile);
       
      
    } else {
      // PC슬라이드 Loop옵션시 마지막 바퀴에서 잘림
      // TODO slidePerView 옵션 개수에 따라 동적으로 값 변경
      option.loopAdditionalSlides = 5;
      item.slidesPerViewPc && (option.slidesPerView = item.slidesPerViewPc);

      // 메인슬라이드는 full-width 클래스때문에 width값 강제로 넣음
      switch (item.displayCd) {
        // case 22:
        //   option.width = 1180;
        //   break;
        case 26:
          option.width = 940; // css에 있는 변수값 참조 : $main-slide-width
          option.slidesPerView = 2;
          option.centeredSlides = false;       
          break;
        case 27:
          // 일단 넣어봄
          option.width = 1912; // css에 있는 변수값 참조 : $main-slide-width2
          option.slidesPerView = "auto";
          option.centeredSlides = false;          
          break;
        case 1:
          // 센터정렬(1번 슬라이드)
          option.centeredSlides = false;
          // 기본 마진값 세팅
          option.spaceBetween = 10;
          // 페이징 스타일 제거
          delete option.pagination;
          break;
        case 2:
          // 기본 마진값 세팅
          option.spaceBetween = 10;
          break;
      }
    }
    return option;
  }

  async mounted() {
    let layoutOVO = this.layoutVo;
    // 재귀 호출일 경우 layoutOVO가 없음(layoutCd만 있음) 예) 탭메뉴
    layoutOVO ||
      (this.layoutCd &&
        (await axios.get(`/main/layouts/${this.layoutCd}`).then((r) => {
          layoutOVO = r.data;
        })));

    // 레이아웃 구조 생성
    this.layout = this.createLayoutStructure(layoutOVO);
    // AI추천상품(내가본상품) 이 있으면 - ml 서버 api는 async 로드
    if (this.layout.displays.filter((display) => display.displayCd == 20).length) {
      const productCds = CommonUtils.getLocalStorageObject(Constants.RECENT_PRODUCTS);
      // 2개 이상 쌓였을 때 추천함
      productCds &&
        productCds.length >= 2 &&
        axios.get("/product/recommendations", { params: { productCds: productCds } }).then((r) => {
          if (this.$route.name == "Main") {
            this.aiRecommendedProducts = r.data;
          }
        });
    }

    this.onLayoutUpdated();
    window.addEventListener("scroll", this.handleScroll);
  }


  beforeDestory() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}
